<template>
    <div class="ClassicCaseListBox">
        <div v-if="caseListShow">
            <div class="tools">
                <h2 class="title">课件资源</h2>
                <Input v-model="keyWord" class="search">
                    <Button slot="append" icon="ios-search" @click="search"></Button>
                </Input>
            </div>
            <div class="content">
                <div class="contentLeft">
                    <div v-for="(i, index) in categoryAs" :class="['categoryA',i.name==categoryA.name?'actived':'']" @click="checkA(i)">
                        <span>{{i.name}}</span>
                    </div>
                </div>
                <div class="contentRight">
                    <div class="tools">
                        <span class="name">分类：</span>
                        <div :class="['categoryB', i.name==categoryB.name?'actived':'']" v-for="(i, index) in categoryBs" :key="index" @click="checkB(i)">{{i.name}}</div>
                    </div>
                    <div>
                        <case v-for="(i, index) in allData" :key="index" :info="i" @click.native="watch(i)"></case>
                    </div>
                    <div class="pageBox">
                        <Page class="page" @on-change="changePage" :page-size="page.limit" show-total :current="page.page" :total="page.totalCount" />
                    </div>
                </div> 
            </div>
        </div>
        <case-info v-else :id="selectId" @cancel="cancel"></case-info>
    </div>    
</template>

<script>
import Case from "./Case"
import CaseInfo from "./CaseInfo"
export default {
    components: {
        Case,
        CaseInfo
    },
    data() {
        return {
            caseListShow: true,
            page: {
                page: 1,
                limit: 10,
                totalCount: 0
            },
            keyWord: "",
            data: [],
            categoryA: {
                name: "全部",
                children: []
            },
            categoryB: {
                name: "全部"
            },
            allData: [],
            selectId: ""
        }
    },
    computed: {
        categoryAs() {
            let arr = [{
                name: '全部',
                children: []
            }]
            arr = arr.concat(this.data)
            return arr
        },
        categoryBs() {
            let arr = [{
                name: '全部',
                children: []
            }]
            arr = arr.concat(this.categoryA.children)
            return arr
        },
        treeData() {
            return function(value) {
                value.forEach(function (item) {
                    delete item.children;
                });
                var map = {};
                value.forEach(function (item) {
                    map[item.id] = item;
                });
                var val = [];
                value.forEach(function (item) {
                    var parent = map[item.ownerId];
                    if (parent) {
                        (parent.children || ( parent.children = [] )).push(item);
                    } else {
                        val.push(item);
                    }
                });
                return val;
            }
        },

    },
    methods: {
        _initData() {
            let data = {
                dictionaryType: 'course'
            }
            this.$api.dictionary.findByType(data).then(res => {
                let data = res.list
                data.map(e => {
                    e.label = e.name
                    e.value = e.name
                })
                this.data = this.treeData(data)
            })
            this.searchData()
        },
        search() {
            this.page = {
                page: 1,
                limit: 3
            },
            this.searchData()
        },
        searchData() {
            let data = {
                page: this.page.page,
                limit: this.page.limit,
                keyWord: this.keyWord,
                industry: this.categoryA.name,
                classType: this.categoryB.name
            }
            if(this.categoryA.name == "全部") {
                data.industry = ""
            }
            if(this.categoryB.name == "全部") {
                data.classType = ""
            }
            this.$api.video.findAllFile(data).then(res => {
                this.allData = res.data.list
                this.page.totalCount = res.data.totalCount
            })
        },
        checkA(value) {
            this.categoryA = value
            this.categoryB = this.categoryBs[0]
            this.searchData()
        },
        checkB(value) {
            this.categoryB = value
            this.searchData()
        },
        changePage(value) {
            this.page.page = value
            this.searchData()
        },
        watch(value) {
            this.selectId = value.id
            this.caseListShow = false
        },
        cancel() {
            this.caseListShow = true
            this.searchData()
        }
    },
    mounted() {
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
    .ClassicCaseListBox{
        .tools{
            border-bottom: 1px solid #dddddd;
            padding: 10px 20px;
            &::after {
                content: "";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
            }
            .title{
                line-height: 36px;
                float: left;
            }
            .search{
                width: 240px;
                float: right;
            }
        }
        .content{
            width: 100%;
            &::after {
                content: "";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
            }
            .contentLeft{
                width: 300px;
                // height: 1000px;
                float: left;
                font-size: 16px;
                margin-right: 10px;
                .categoryA{
                    height: 40px;
                    line-height: 40px;
                    text-indent: 2em;
                    cursor: pointer;
                    &:hover{
                        color: #2d8cf0;
                    }
                }
                .actived{
                    color: #2d8cf0;
                    background: #f0faff;
                    border-right: 2px solid #2d8cf0;
                }
            }
            .contentRight{
                width: 990px;
                // height: 1000px;
                float: right;
                font-size: 16px;
                .tools{
                    .name{
                        float: left;
                        line-height: 32px;
                        margin-right: 20px;
                    }
                    .categoryB{
                        float: left;
                        border: 1px solid #dddddd;
                        padding: 5px 8px;
                        border-radius: 5px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        cursor: pointer;
                        &:hover{
                            color: #2d8cf0;
                        }
                    }
                    .actived{
                        color: #2d8cf0;
                        border-color: #2d8cf0;
                    }
                }
                .pageBox{
                    float: right;
                    margin-top: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/File/FileList.vue